import React from 'react';
import { useTranslation } from 'react-i18next';

type AlertProps = {
  message: string;
  onClose: () => void;
  backButton?: boolean;
  backButtonAction?: () => void;
};

const Alert: React.FC<AlertProps> = ({
  message,
  onClose,
  backButton = false,
  backButtonAction,
}) => {
  const { t } = useTranslation();
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="max-w-[80%] rounded-2xl bg-white px-6 py-5 text-center shadow-xl">
        <p className="mb-4 text-base text-gray-800">{message}</p>
        <button onClick={onClose} className="px-4 py-1 text-lg font-semibold text-blue-600">
          {t('wards.common.ok')}
        </button>
        {backButton && backButtonAction && (
          <button
            onClick={backButtonAction}
            className="px-4 py-1 text-lg font-semibold text-blue-600"
          >
            {t('wards.common.back')}
          </button>
        )}
      </div>
    </div>
  );
};

export default Alert;
